module.exports = __webpack_public_path__ + "img/wasabiIconLarge.b1ebfb42.png";